import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import InnerCliBg from '@/assets/inner-cli-bg.png';
import InnerImage from '@/assets/inner-cli.svg';
import TerminalIcon from '@/assets/inner-terminal-icon.svg';

import css from './index.module.less';

export function SPECModeSection() {
  const { t } = useTranslation();

  return (
    <div className={clsx(css['plan-mode-section'], 'flex flex-col lg:flex-row')}>
      <div className={clsx(css['content-left'])}>
        <img src={TerminalIcon} alt="terminal" className={clsx(css['terminal-icon'])} />
        <h3 className={clsx(css['title'])}>{t('cli.inner.specMode.title')}</h3>
        <div className={clsx(css['description'])}>{t('cli.inner.specMode.description')}</div>
      </div>
      <div
        className={clsx(css['content-right'])}
        style={{
          backgroundImage: `url(${InnerCliBg})`,
          backgroundSize: 'cover',
        }}
      >
        <img src={InnerImage} alt="终端" className={clsx(css['image'])} />
      </div>
    </div>
  );
}
